'use strict';

import { Component, Input } from '@angular/core';

@Component({
  selector: 'relief-button',
  templateUrl: './relief-button.component.html',
  styleUrls: ['./relief-button.component.scss']
})
export class ReliefButtonComponent {
  @Input() loading = false;
  @Input() processing = false;
  @Input() valid = false;
  @Input() classes = 'btn-primary';
  @Input() title: string;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/relief-button/relief-button.component.ts